import { Box, Button, FormGroup, Modal, Stack, TextField, Typography } from "@mui/material";
import { SectorData, SectorDataError } from "../../types";
import { useAPI } from "../../hooks/useAPI";
import { useEffect, useState } from "react";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import { ConfirmDialog } from "../../components/global/ConfirmDialog";

interface SectorModalProps {
  open: boolean;
  handleClose:() => void;
  handleSave:() => void;
  sector: SectorData;
}

export const SectorModal = ({open, handleClose, handleSave, sector}: SectorModalProps) => {
  const [mSector, setMSector] = useState<SectorData>(sector);
  const [error, setError] = useState<SectorDataError>({});
  const { fetchData } = useAPI();
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  useEffect(() => {
    setMSector({ ...sector});
  }, [sector]);

  const onSaveSector = async (sector: SectorData) => {
    const {errors, data} = await fetchData('/sectors/save',  sector, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  const onDeleteSector = async (sector: SectorData) => {
    const {errors, data} = await fetchData('/sectors/delete',  { id: sector.id }, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
        maxHeight: '90%',
        overflow: 'auto',
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600">
          { sector.id ? "Edit Sector" : "Add Sector" }
        </Typography>
        <Stack mt={4} spacing={4}>
          <FormGroup>
            <Typography fontWeight="600">Name</Typography>
            <TextField
              variant="outlined"
              value={mSector.name}
              error={error.name ? true : false}
              helperText={error?.name?.[0] ?? ''}
              onChange={(e) => setMSector({ ...mSector, name: e.target.value })}
              sx={{ width: '100%' }}
            />
          </FormGroup>
          <FormGroup>
            <Stack direction='row' spacing={2}>
              <Button variant="contained" size="large" onClick={() => onSaveSector(mSector)}>
                Save Sector
              </Button>
              {
                sector.id && (
                  <Button variant="outlined" size="large" color="error" onClick={() => 
                    openDialog(
                      "Confirm Deletion",
                      `Are you sure you want to delete the sector "${mSector.name}"?`,
                      () => onDeleteSector(mSector)
                    )
                  }>
                    Delete Sector
                  </Button>
                )
              }
              <Button variant="text" size="large" onClick={handleClose}>
                Cancel
              </Button>
            </Stack>
          </FormGroup>
        </Stack>
        <ConfirmDialog
          open={isOpen}
          title={config.title}
          description={config.description}
          onConfirm={config.onConfirm}
          onClose={closeDialog}
        />
      </Box>
    </Modal>
  )
}